import axios from 'axios';
import { GET_GROUPINGS, API_HOST } from './const';

const API_URL = '/api/Gym/GetGroupings/';
export default () => {
  const url = `${API_HOST}${API_URL}`;
  const request = axios.get(url);

  return {
    type: GET_GROUPINGS,
    payload: request,
  };
};
